import React, { useCallback, useRef, useEffect, useState, forwardRef, useImperativeHandle, } from "react";
import ReactFlow, { addEdge, useNodesState, useEdgesState, Controls, useReactFlow, Position, MarkerType, Panel, reconnectEdge, } from "reactflow";
import "reactflow/dist/style.css";
import "../Tab Content/Subflow Template Contents/Subflow Template Creation.css";
import { useDnD } from "../DnD_component/DnDContext";
import nodeTypes from "../../Pages/AppNoDeleteNode";
import CustomEdge from "../Node_Edge Components/Stencils/CustomEdge";
import * as htmlToImage from "html-to-image";
import ELK from "elkjs/lib/elk.bundled.js";
import BiDirectionalEdge from "../Node_Edge Components/Bi-Directional_edge";
import { IconButton, Tooltip } from "@mui/material";
import alignNormal from "../../Assets/autoalign-normal.svg";
import alignHover from "../../Assets/autoalign-hover.svg";
import { SlArrowLeftCircle } from "react-icons/sl";
import WorkflowTemplateServiceController from "../../Controllers/WorkflowTemplateservice";
import SubFlowNode from '../Node_Edge Components/Stencils/subflowNode';

//Global declarations
//Declared initial data here - reused inside the WorkflowCanvas with the help of useRef
const initialData = {
  nodes: [],
  edges: [],
};
const initialNodes = initialData.nodes.length !== 0 ? initialData.nodes : [];
const initialEdges = initialData.edges.length !== 0 ? initialData.edges : [];
// used for elk js library for auto aligning the diagram
// used for elk js library for auto aligning the diagram
const elk = new ELK();

const elkOptions = {
  "elk.algorithm": "layered",
  "elk.layered.spacing.nodeNodeBetweenLayers": "45",
  "elk.spacing.nodeNode": "20",
  "elk.graphviz.overlapMode": "SCALE",
  "elk.edgeRouting": "ORTHOGONAL",
  "elk.alignment": "CENTER",
};

const getLayoutedElements = (nodes, edges, options = {}) => {
  const isHorizontal = options?.["elk.direction"] === "RIGHT";

  const graph = {
    id: "root",
    layoutOptions: options,
    children: nodes.map((node) => ({
      ...node,
      targetPosition: isHorizontal ? "left" : "top",
      sourcePosition: isHorizontal ? "right" : "bottom",

      // ✅ SAFE SIZE (prevents giant nodes)
      width: node.width || 180,
      height: node.height || 60,
    })),
    edges: edges,
  };

  return elk.layout(graph).then((layoutedGraph) => ({
    nodes: layoutedGraph.children.map((node) => ({
      ...node,
      position: { x: node.x, y: node.y },
    })),
    edges: layoutedGraph.edges,
  }));
};
//Declared edge types
const edgeTypes = {
  edges: CustomEdge,
  biDirectional: BiDirectionalEdge,
};

//start of class
const WorkflowCanvasView = forwardRef((props, ref) => {
  //used for receiving parameters - format is different due to the usage of forwardref
  let { workflow, emptyDropdown, handleSubflowCanvasClick, json, isSubflow, isTransaction, dropdownData, createEvent, onParentNodeClick ,...rest } = props;
  const [allJson, setAllJson] = useState(json);
  useEffect(() => {
  }, [isSubflow, json, dropdownData]);

  const initialDataRef = useRef({
    nodes: allJson.nodes ?? [],
    edges: allJson.edges ?? []
  });

  // Modified getHighestId function with debugging
  const getHighestId = (nodes, edges) => {
    const nodeIds = nodes.map(node => {
      const id = parseInt(node.id);
      return id;
    });

    const edgeSourceIds = edges.map(edge => {
      const id = parseInt(edge.source);
      return id;
    });

    const edgeTargetIds = edges.map(edge => {
      const id = parseInt(edge.target);
      return id;
    });

    const allIds = [...nodeIds, ...edgeSourceIds, ...edgeTargetIds];
    const maxId = allIds.length > 0 ? Math.max(...allIds) : -1;
    return maxId;
  };

  // Initialize the counter with the highest existing ID + 1
  const idCounterRef = useRef(
    getHighestId(initialDataRef.current.nodes, initialDataRef.current.edges) + 1
  );
  // Modified getId function
  const getId = useCallback(() => {
    const newId = `${idCounterRef.current}`;
    console.log('Generated new ID:', newId);
    idCounterRef.current += 1;
    return newId;
  }, []);
  // Use this function when generating edge IDs to ensure uniqueness
  const generateCustomEdgeId = useCallback((source, target) => {
    const edgeId = `edge-${source}-${target}-${idCounterRef.current}`;
    idCounterRef.current += 1;
    return edgeId;
  }, []);
  // Add tracking of current counter value
  useEffect(() => {
    console.log('Current ID counter:', idCounterRef.current);
  }, [idCounterRef.current]);

  const [nodes, setNodes, onNodesChange] = useNodesState(initialDataRef.current.nodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialDataRef.current.edges);
  //To determine the position on canvas
  const { screenToFlowPosition } = useReactFlow();
  //context provider
  const [type] = useDnD();
  const { fitView } = useReactFlow();
  const [selectedNode, setSelectedNode] = useState(null);
  const [selectedEdge, setSelectedEdge] = useState(null);
  const [isPropertyVisible, setIsPropertyVisible] = useState(false);
  const edgeReconnectSuccessful = useRef(true);
  const [edgeLabel, setEdgeLabel] = useState("");
  const [selectedElement, setSelectedElement] = useState(null);
  const reactFlowWrapper = useRef(null);
  const [layoutComplete, setLayoutComplete] = useState(false);
  const [control_panel, setControl_Panel] = useState(true);
  const [connected, setConnected] = useState(false);
  const [originalEdgeStyles, setOriginalEdgeStyles] = useState({});
  const [warning, setWarning] = useState(false);
  const [sidebar, setSidebar] = useState(workflow);
  const [canvasClickTriggered, setCanvasClickTriggered] = useState(false);
  const recData = {};
  const permissionData = {
    " hrRecruiter": {
      " read": true,
      " write": false,
      hide: false,
    },
  };

  const onConnectStart = (event, { nodeId, handleId }) => {
    //  console.log(`Started dragging from node ${nodeId}, handle ${handleId}`);
  };

  const onConnect = useCallback((params) => {
    const customEdgeId = generateCustomEdgeId(
      params.sourceHandle,
      params.targetHandle
    );
    setConnected(true);
    //defining the edge parametes on connect
    setEdges((eds) =>
      addEdge(
        {
          ...params,
          id: customEdgeId, // Use the custom ID
          type: "edges",
          label: "", // Set the label to an empty string
          animated: false,
          markerEnd: {
            type: MarkerType.ArrowClosed,
            width: 10,
            height: 10,
            color: "#121b45",
          },
        },
        eds
      )
    );
  }, []);

  const onConnectEnd = (event) => {
    //  console.log("Connection ended");
  };

  //For elk js library
  const onLayout = useCallback(
    ({ direction, useInitialNodes = false }) => {
      const opts = { "elk.direction": direction, ...elkOptions };
      const ns = useInitialNodes ? initialNodes : nodes;
      const es = useInitialNodes ? initialEdges : edges;
      getLayoutedElements(ns, es, opts).then(
        ({ nodes: layoutedNodes, edges: layoutedEdges }) => {
          setNodes(layoutedNodes);
          setEdges(layoutedEdges);
          setLayoutComplete(true);
          //window.requestAnimationFrame(() => fitView());
        }
      );
    },

    [nodes, edges]
  );

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  //Deletion of nodes and edges
  const onDelete = useCallback((id) => {
    setNodes((nds) => nds.filter((node) => node.id !== id));
    setEdges((eds) =>
      eds.filter((edge) => edge.source !== id && edge.target !== id)
    );
  },
    [setNodes, setEdges]
  );

  //Function called from subflow node
  const handleCanvasClick = useCallback((level, index, isEditSubflow, Json, subFlow, id, eventDetails) => {
    console.log('handle subflow canvas click in workflow canvas,', eventDetails);
    //Function passed to workflow tab

    if (isTransaction) {
      let subjson = allJson.nodes.filter((n) => n.id === id);
      setAllJson(subjson[0].data.nodeData);
      setSidebar(false);

      // Toggle the state
    }
    else {
      let editEventDetails = eventDetails;
      if (typeof editEventDetails === "string") {
        editEventDetails = JSON.parse(editEventDetails);
        console.log("obj:", editEventDetails);
      }
      else {
        console.log(eventDetails, typeof eventDetails);
      } 
      handleSubflowCanvasClick(level, index, isEditSubflow, Json, subFlow, false, editEventDetails);
    } 
  }, []);

  useEffect(() => {
  if (allJson?.nodes && allJson?.edges) {

    // ✅ CLEAN NODES (fix oversized issue)
    const cleanedNodes = allJson.nodes.map((node) => ({
      ...node,
      style: {}, // remove bad width/height from JSON
      data: {
        ...node.data,
        label: node.data?.label || "", // avoid undefined
      },
    }));

    setNodes(cleanedNodes);
    setEdges(allJson.edges);

    // ✅ AUTO LAYOUT AFTER LOAD
    onLayout({ direction: "DOWN" });

    setCanvasClickTriggered((prev) => !prev);
  }
}, [allJson]);


  //updating the values of node
  const updateNodeLabel = useCallback(
    (id, newLabel, icon, color, recData, permissionData, eventDetails, active, assignTo) => {
      //setting new parameters for node
      setNodes((nds) =>
        nds.map((node) => {
          if (node.id === id) {
            // console.log('node update if');
            const updatedNode = {
              ...node,
              data: {
                ...node.data,
                label: newLabel,
                assignTo: assignTo,
                icon: icon,
                color: color,
                recData: recData,
                permissionData: permissionData,
                eventDetails: eventDetails,
                eventId: eventDetails?.eventId ?? null,
                active: active
              },
            };
            return updatedNode;
          }
          return node;
        })
      );
    },

    [setNodes,]
  );


  //Addition of new node
  const onAdd = useCallback((id, type) => {
    console.log("dropdowndata in canvas", dropdownData);
    setNodes((currentNodes) => {
      const sourceNode = currentNodes.find((node) => node.id === id);
      //setting the position of new node
      const newPosition = {
        x: sourceNode.position.x + 150,
        y: sourceNode.position.y + 100,
      };
      // const imageSrcValue = sourceNode.data.label;
      // const label = 'type';
      if (type !== "icon" || "dragDropNode") {
        let newNode = {
          id: getId(),
          type,
          position: newPosition,
          data: {
            label: "",
            onDelete,
            onAdd,
            updateNodeLabel,
            handleCanvasClick,
            icon: null,
            color: "#fff",
            fontColor: "#000",
            fontSize: "12px",
            fontStyle: "normal",
            recData: recData,
            permissionData: permissionData,
          },
        };
        return [...currentNodes, newNode];
      }
    });
  },
    [setNodes]
  );


  // Key fixes in the useEffect for mapping callback functions to nodes
  useEffect(() => {
    if (nodes.length > 0) {
      // Create a deep copy of nodes to avoid direct state mutation
      const nodesWithCallbacks = nodes.map((node) => ({
        ...node,
        data: {
          ...node.data,
          onDelete: (id) => {
            setNodes((nds) => nds.filter((node) => node.id !== id));
            setEdges((eds) => eds.filter((edge) => edge.source !== id && edge.target !== id));
          },
          onAdd: (id, type) => {
            setNodes((currentNodes) => {
              const sourceNode = currentNodes.find((node) => node.id === id);
              if (!sourceNode) return currentNodes;

              const newPosition = {
                x: sourceNode.position.x + 150,
                y: sourceNode.position.y + 100,
              };

              const newNode = {
                id: getId(),
                type,
                position: newPosition,
                data: {
                  label: "",
                  onDelete,
                  onAdd,
                  updateNodeLabel,
                  icon: null,
                  color: "#fff",
                  fontColor: "#000",
                  fontSize: "12px",
                  fontStyle: "normal",
                  recData,
                  permissionData,
                },
              };
              return [...currentNodes, newNode];
            });
          },
          updateNodeLabel,
          handleCanvasClick,
        }
      }));

      // Update nodes only if they've actually changed
      setNodes(currentNodes => {
        const hasChanged = currentNodes.some((node, index) => {
          const newNode = nodesWithCallbacks[index];
          return !newNode ||
            node.id !== newNode.id ||
            node.data.label !== newNode.data.label ||
            !node.data.onDelete ||
            !node.data.onAdd;
        });
        return hasChanged ? nodesWithCallbacks : currentNodes;
      });
    }
  }, [nodes, setNodes, setEdges, getId, updateNodeLabel, handleCanvasClick, recData, permissionData, canvasClickTriggered]);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();
      setIsPropertyVisible(false);
      const position = screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      });

      let newNode;
      let nodeType;
      let level;
      let levelId;
      let eventDetails;
      let duplicateFound = false;

      if (!newNode) {
        nodeType = event.dataTransfer.getData("application/reactflow");
        level = event.dataTransfer.getData("level");
        levelId = event.dataTransfer.getData("levelId");
        eventDetails = event.dataTransfer.getData("eventDetails");
        if (
          nodeType !== "icon" &&
          nodeType !== "dragDropNode" &&
          nodeType !== "customNode"
        ) {
          console.log('eventId', eventDetails);
          newNode = {
            id: getId(),
            type: nodeType,
            position,
            sourcePosition: Position.Right,
            targetPosition: Position.Left,
            data: {
              label: "",
              assignTo: null,
              level: undefined,
              eventDetails: eventDetails,
              onDelete,
              onAdd,
              handleCanvasClick,
              updateNodeLabel,
              icon: null,
              color: "#fff",
              fontColor: "#000",
              fontSize: "12px",
              fontStyle: "normal",
              eventId: null,
              active: false,
              recData: recData,
              permissionData: permissionData,
            },
          };
        } else if (nodeType === "subflowNode") {


          newNode = {
            id: getId(),
            type: nodeType,
            position,
            sourcePosition: Position.Right,
            targetPosition: Position.Left,
            data: {
              label: level,
              level: level,
              levelId: levelId,
              onDelete,
              onAdd,
              handleCanvasClick,
              updateNodeLabel,
              icon: null,
              color: "#fff",
              fontColor: "#000",
              fontSize: "12px",
              fontStyle: "normal",
              recData: recData,
              permissionData: permissionData,

            },
          };

        } else {
          console.error("No node type found in drag data");
          return;
        }
      }

      if (workflow) {
        //console.log('checking if workflow');
        nodes.map((node) => {
          console.log("dropping new node");
          console.log('into if duplicate', node.data.label, newNode.data.label);
          if (node.data.label === newNode.data.label) {
            console.log('into if duplictae', node.data.label, newNode.data.label);
            duplicateFound = true;
            alert('The level you are trying to drag and drop already exists');
          }
        });
      }
      if (!duplicateFound) setNodes(currentNodes => [...currentNodes, newNode]);
    },
    [screenToFlowPosition, onDelete, onAdd, updateNodeLabel, recData, permissionData, handleCanvasClick,]
  );

  useEffect(() => {
    if (workflow) {
      updateNodesWithIncomingData();
    }
  }, [workflow]);

  const [workflowLevelComp, setWorkflowLevelComp] = useState([]);
  const workflowTempCont = new WorkflowTemplateServiceController();

  const updateNodesWithIncomingData = async () => {
    const body = await workflowTempCont.getSidebarComponents();
    console.log(body);
    setWorkflowLevelComp(
      Array.isArray(body) && body.length > 0 ?
        body.map((levelComp, index) => ({
          id: levelComp.id,
          levelCode: levelComp.levelCode,
          levelName: levelComp.levelName,
          mappedsubflowId: levelComp.mappedSubflowId
        })
        )
        :
        []
    )
    // Update nodes by matching the label with levelName
    setNodes(prevNodes => {
      const updatedNodes = [...prevNodes];
      workflowLevelComp.forEach(levelComp => {
        const nodeIndex = updatedNodes.findIndex(node => node.data.label === levelComp.levelName);
        if (nodeIndex !== -1) {
          updatedNodes[nodeIndex].data.levelId = levelComp.mappedSubflowId;
          console.log('Updated node:', updatedNodes[nodeIndex]);
        }
      });
      return updatedNodes;
    });
  }
  const onNodeClick = useCallback((event, node) => {
    //console.log("on node click",node);
    setSelectedNode(node);
    setSelectedElement(null);
    setIsPropertyVisible(true);
    fitView();

    const allNodes = document.querySelectorAll(".node"); // Assuming nodes have a class 'node'
    allNodes.forEach((n) => n.classList.remove("selected-node")); // Remove indication from all nodes
    event.currentTarget.classList.add("selected-node"); // Add indication to the clicked node

    // Update the node data to show icons
    setNodes((nds) =>
      nds.map((n) => {
        if (n.id === node.id) {
          // Set showIcons to true for clicked node
          return {
            ...n,
            data: {
              ...n.data,
              showIcons: false
            }
          };
        } else {
          // Hide icons for all other nodes
          return {
            ...n,
            data: {
              ...n.data,
              showIcons: false
            }
          };
        }
      })
    );

    setEdges((prevEdges) =>
      prevEdges.map((edge) => {
        const { animation, ...restStyle } = edge.style || {};
        return {
          ...edge,
          animated: edge.animated,
          style: restStyle,
        };
      })
    );
    onParentNodeClick?.(node); // parent handles API fetch & subJson update
  },  [onParentNodeClick, fitView, setNodes, setEdges]);

  const updateEdgeLabel = useCallback(
    (edgeId, newLabel, edgeStyle, edgeAnimation) => {
      //console.log('edgeLabel in update edge',newLabel);
      setEdges((eds) =>
        eds.map((edge) => {
          if (edge.id === edgeId) {
            const updatedEdge = {
              ...edge,
              label: newLabel,
              style: edgeStyle,
              animated: edgeAnimation,
            };

            return updatedEdge;
          }
          return edge;
        })
      );
    },
    [setEdges]
  );

  const onElementClick = useCallback((event, element) => {
    if (element.source && element.target) {
      setSelectedElement(element);
      setSelectedEdge(element);
      setSelectedNode(null);
      setIsPropertyVisible(true);

      setOriginalEdgeStyles((prevStyles) => ({
        ...prevStyles,
        [element.id]: {
          style: element.style,
          animated: element.animated,
        },
      }));

      setEdges((prevEdges) =>
        prevEdges.map((edge) => {
          if (edge.id === element.id) {
            return {
              ...edge,
              label: element.label,
              animated: element.animated,
              style: {
                ...edge.style,
                animation: "rainbow 5s linear infinite",
              },
            };
          } else {
            //const { animation, ...restStyle } = edge.style || {};
            return {
              ...edge,
              label: edge.label,
              animated: edge.animated,
              style: {
                ...edge.style,
                animation: "", // Remove animation for other edges
              },
            };
          }
        })
      );

      const allNodes = document.querySelectorAll(".node");
      allNodes.forEach((n) => n.classList.remove("selected-node"));
    } else {
      setSelectedNode(element);
      setSelectedElement(element);
      setSelectedEdge(null);
      setIsPropertyVisible(true);
      setEdges((prevEdges) =>
        prevEdges.map((edge) => {
          const { animation, ...restStyle } = edge.style || {};
          return {
            ...edge,
            label: edge.label,
            animated: edge.animated,
            style: edge.style,
          };
        })
      );
    }

  },
    [setEdges]
  );
  useEffect(() => {
    //console.log('edges in useeffect',selectedEdge);
  })
  const onReconnectStart = useCallback(() => {
    edgeReconnectSuccessful.current = false;
  }, []);

  const onReconnect = useCallback((oldEdge, newConnection) => {
    edgeReconnectSuccessful.current = true;
    setEdges((els) => reconnectEdge(oldEdge, newConnection, els));
  }, []);

  const onReconnectEnd = useCallback((_, edge) => {
    if (!edgeReconnectSuccessful.current) {
      setEdges((eds) => eds.filter((e) => e.id !== edge.id));
    }
    edgeReconnectSuccessful.current = true;
  }, []);


  const exportToJson = () => {
    fitView();

    setNodes((nds) =>
      nds.map((n) => {
        if (true) {
          // Set showIcons to true for clicked node
          return {
            ...n,
            data: {
              ...n.data,
              showIcons: false
            }
          };
        }
      })
    );
    const allNodes = document.querySelectorAll(".selected-node"); // Assuming nodes have a class 'node'
    allNodes.forEach((n) => n.classList.remove("selected-node"));
    const flowObject = {

      nodes: nodes.map((node) => ({
        id: node.id,
        type: node.type,
        position: node.position,
        data: {
          ...node.data,
          showIcons: false // Set showIcons to false for all nodes
        },
      })),

      edges: edges.map((edge) => ({
        id: edge.id,
        source: edge.source,
        target: edge.target,
        sourceHandle: edge.sourceHandle, // Include source handle ID
        targetHandle: edge.targetHandle, // Include target handle ID
        type: edge.type,
        label: edge.label,
        markerEnd: edge.markerEnd,
        style: edge.style,
        animated: edge.animated,
      })),
      dropdownData: dropdownData,
    };
    const jsonString = JSON.stringify(flowObject, null, 2);
    // console.log("saved dropdowns", jsonString.dropdownData);
    // console.log("Saved JSON:", jsonString);
    return jsonString;
  };
  //used because of the usage of forward ref
  //Any function, in this page which needs to be called in another page using forward ref, has to be mentioned here
  useImperativeHandle(ref, () => ({
    exportToJson,
    exportToSVG,
    checkingUnconnectedNodes,
    checkEmptyDiagram,
    checkEmptyNodes
  }));

  const exportToSVG = async () => {
    if (nodes.length !== 0) {
      const node = document.getElementsByClassName("react-flow")[0];
      const controls = document.querySelector(".react-flow__controls");
      const panels = document.querySelector(".react-flow__panel");

      // Check if controls and panels exist before setting their display property
      if (controls) {

        controls.style.display = "none";
      } else {
        console.log("Controls not found");
      }

      if (panels) {

        panels.style.display = "none";
      } else {
        console.log("Panels not found");
      }

      try {
        // Get SVG data URL

        //  const svgDataUrl = await htmlToImage.toSvg(node);
        //  localStorage.setItem("flowImage", svgDataUrl);
        //  console.log("Image saved to local storage with dimensions",svgDataUrl);


        // Convert SVG to JPG
        const jpgDataUrl = await htmlToImage.toJpeg(node, {
          quality: 0.95,
          backgroundColor: '#F6F7FC'
        });
        localStorage.setItem("flowImageJPG", jpgDataUrl);
        // Convert the JPG data URL to a byte array
        const byteString = atob(jpgDataUrl.split(',')[1]);
        const byteArray = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
          byteArray[i] = byteString.charCodeAt(i);
        }
        return byteArray;

      } catch (error) {
        console.error("Error capturing diagram:", error);
      } finally {
        // Show controls and panels again if they exist
        if (controls) {

          controls.style.display = "";
        }
        if (panels) {

          panels.style.display = "";
        }
      }
    } else {
      console.log("nothing to export");
    }
  };


  const onPropertiesTabClose = () => {
    setIsPropertyVisible(false);
  };

  //To call the fitview after auto aligning the diagram
  useEffect(() => {
    if (layoutComplete) {
      fitView({ padding: 0.2 });
      setLayoutComplete(false); // Reset the layout complete state
    }
  }, [layoutComplete]);

  const checkUnconnectedNodes = (nodes, edges) => {
    const connectedNodeIds = new Set();
    edges.forEach((edge) => {
      connectedNodeIds.add(edge.source);
      connectedNodeIds.add(edge.target);
    });
    const unconnectedNodes = nodes.filter(
      (node) => !connectedNodeIds.has(node.id)
    );
    return unconnectedNodes;
  };


  const checkingUnconnectedNodes = () => {
    const unconnectedNodes = checkUnconnectedNodes(nodes, edges);
    if (unconnectedNodes.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const checkEmptyDiagram = () => {
    if (nodes.length === 0) return true;
    return false;
  }
  const checkEmptyNodes = () => {
    let hasEmptyLabel = false;
    nodes.forEach((node) => {
      console.log(node.data.label);
      if (node.data.label === "") {
        hasEmptyLabel = true;
      }
    });
    return hasEmptyLabel;
  };
  //Function to be called on clicking the inital div in the workflow template canvas
  const generateTemplateNode = () => {
    if (emptyDropdown) {
      setWarning(true);
    }
    else {
      //console.log('go to API call');
    }
  };
  const closeWarning = () => {
    setWarning(false);
  };
  const canvasReturnClick = () => {
    setSidebar(true);
    //  console.log("return", json);
    setAllJson(json);
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: "78vh",
          width: "98%",
          background: "#F6F7FC",
          padding: "0px 6px",
          border: "1px solid #CFD4E9",
        }}
        {...rest}
      >
        {/* {!emptyDropdown && */}

        {/* } */}
        <div
          style={{
            height: "75vh",
            width: "100%",
            background: "#F6F7FC",
            padding: "5px",
          }}
        >
          <div className="reactflow-wrapper" ref={reactFlowWrapper}>          

            <ReactFlow             
              nodes={nodes}
              edges={edges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onNodeClick={onNodeClick}
              onConnect={onConnect}
              onConnectStart={onConnectStart}
              onConnectEnd={onConnectEnd}
              onDragOver={onDragOver}
              onDrop={onDrop}
              nodeTypes={nodeTypes}
              onEdgeClick={onElementClick}
              onReconnect={onReconnect}
              onReconnectStart={onReconnectStart}
              onReconnectEnd={onReconnectEnd}
              edgeTypes={edgeTypes}
            >
              {control_panel && (
                <>
                  <Controls />
                  {/* For any html element to be clickable, it must be enclosed within Panel tag */}
                  <Panel position="top-right">
                    <Tooltip title="Align Diagram">
                      <IconButton
                        size="large"
                        onClick={() => {
                          //here direction is explicitly mentioned as top to bottom. To horizontally align change the direction to right
                          onLayout({ direction: "DOWN" });
                        }}
                        onDragStart={(e) => e.preventDefault()}
                      >
                        <div className="align-icon">
                          <ul>
                            <li>
                              <img src={alignHover} alt="align-icon" />
                            </li>
                            <li>
                              <img src={alignNormal} alt="align-icon" />
                            </li>
                          </ul>
                        </div>
                      </IconButton>
                    </Tooltip>
                  </Panel>
                </>
              )}

             
            </ReactFlow>
          </div>
        </div>


      </div>
    </>
  );
});

export default WorkflowCanvasView;
